export default __webpack_public_path__ + "static/media/createYourOwn.e5c21e84.svg";